<template>
	<!-- type='number' in combination with vue-the mask overwrites every char -->
	<!-- type='tel' also opens number keyboard on mobile -->
	<BaseInput
		ref="BaseInput.time"
		:required="required"
		:label="label"
		:placeholder="placeholder"
		type="tel"
		v-model="model"
		maxlength="5"
		:mask="['NN:NN', 'N:NN']"
		validation="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
		:error-message="$t('enter_valid_time')"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>
<script>
import BaseInput from '../../forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';

export default {
	name: 'TimeInput',
	components: { BaseInput },
	mixins: [Validate],
	props: {
		value: {},
		label: {
			default: function() {
				return this.$t('time');
			},
			required: false,
		},
		placeholder: { default: '12:00', required: false },
		required: { default: false },
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
	methods: {
		isValueValid(value) {
			return this.$refs['BaseInput.time'].isValueValid(value);
		},
	},
};
</script>
